import { Box, Button, Checkbox, Container, FormControlLabel, IconButton, InputAdornment, makeStyles, Typography } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { startLogin } from '../../../actions/auth';
import { useForm } from '../../../hooks/useForm';
import ReactStoreBadges from 'react-store-badges'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  submit: {
    marginTop: "1rem",
    textTransform: "none",
  },
  title: {
    fontWeight: "bold",
    fontStyle: "italic"
  }
}));

const LoginScreenAfiliado = (props) => {
  const { history } = props
  const classes = useStyles()
  const dispatch = useDispatch()

  const [recordar, setRecordar] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const initialState = {
    dni: "",
    password: ""
  };

  const [formValues, handleInputChange] = useForm(initialState);
  const { dni, password } = formValues;

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(startLogin(dni, password, recordar, history, true));
  };

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="xs">
          <ValidatorForm onSubmit={handleLogin}>
            <Box p="1rem">
              <Typography align="center" variant="h4" className={classes.title} color="primary">Mi OSPEDYC</Typography>
              <Typography align="center" variant="h6"  color="primary" style={{marginTop:"0.5rem"}}>¡Hola!</Typography>
              <Typography align="center" variant="body2" color="secondary">Ingresá tu DNI y contraseña para acceder a tu perfil:</Typography>

              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="DNI"
                onChange={handleInputChange}
                name="dni"
                validators={['required']}
                errorMessages={['El DNI es requerido']}
                value={dni}
              />
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="Contraseña"
                onChange={handleInputChange}
                name="password"
                validators={['required']}
                errorMessages={['La contraseña es requerida']}
                value={password}
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    value="remember"
                    onChange={(e) => setRecordar(e.target.checked)}
                    checked={recordar}
                    color="primary"
                  />
                }
                label="Recordar"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Ingresar
              </Button>
              <div style={{ marginTop: "0.5rem", textAlign: "center" }} >
                <Link to="/afiliado/olvide-password">
                  <Typography color="primary" variant="caption" >No recuerdo mi contraseña</Typography>
                </Link>
              </div>
              <Button
                component={Link}
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                to="/afiliado/registro"
              >
                Registrarse
              </Button>
            </Box>
          </ValidatorForm>
          <Box p="1rem" pt={0} style={{justifyContent: "space-around", alignItems:"center", display:"flex"}}>
          <ReactStoreBadges
              platform={'ios'}
              url={'https://apps.apple.com/us/app/mi-ospedyc/id1583957788?itsct=apps_box_link&itscg=30200'}
              locale={'es-es'}
              target="_blank"
            />
            <ReactStoreBadges
              platform={'android'}
              url={'https://play.google.com/store/apps/details?id=com.miospedyc'}
              locale={'es-es'}
              target="_blank"
            />
          </Box>
        </Container>
      </Box>
    </div>
  )
}

export default LoginScreenAfiliado
